<template>
  <Header></Header>
  <div class="app-content">
    <router-view />
  </div>
</template>

<script>
import Header from '@/components/Header'
import ResizeHandler from '@/mixin/ResizeHandler'

export default {
  name: 'App',
  mixins: [ResizeHandler],
  components: { Header },
}
</script>

<style lang="scss">
body {
  background-color: #eeeeee !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.app-content {
  width: 1000px;
  max-width: 100%;
  overflow: hidden;
  padding-top: 70px;
  margin: 0 auto;
}
@media screen and (max-width: 750px) {
  .app-content {
    padding-top: 60px;
  }
}
</style>
